(function () {
  const AUTOSCROLL_DELAY_MS = 400;
  const AUTOSCROLL_SPEED = 0.6;

  function loopSlides(slides) {
    if (!slides.length) return slides;
    return slides.length < 10 ? slides.concat(slides) : slides;
  }

  function openMarqueeLightbox(viewport, slides, card) {
    const index = Number(card.dataset.marqueeIndex);
    if (!Number.isFinite(index)) return;
    viewport.dispatchEvent(
      new CustomEvent('marquee:open', {
        bubbles: true,
        detail: { index: index % slides.length, slides },
      }),
    );
  }

  function initRow(viewport, slides, direction) {
    if (!viewport || !slides.length || typeof EmblaCarousel === 'undefined') return null;

    const track = viewport.querySelector('.mindpatterns-marquee__track');
    const overlay = viewport.querySelector('.mindpatterns-marquee__overlay');
    const plugins = [];

    if (typeof EmblaCarouselAutoScroll !== 'undefined') {
      plugins.push(
        EmblaCarouselAutoScroll({
          speed: AUTOSCROLL_SPEED,
          direction: direction === 'backward' ? 'backward' : 'forward',
          stopOnInteraction: false,
          stopOnMouseEnter: false,
          startDelay: AUTOSCROLL_DELAY_MS,
        }),
      );
    }

    const embla = EmblaCarousel(
      viewport,
      {
        loop: true,
        dragFree: true,
        align: 'start',
        containScroll: false,
      },
      plugins,
    );

    embla.on('pointerDown', () => viewport.classList.add('is-dragging'));
    embla.on('pointerUp', () => viewport.classList.remove('is-dragging'));

    if (overlay) {
      let down = null;

      overlay.addEventListener('pointerdown', (event) => {
        down = { x: event.clientX, y: event.clientY };
        overlay.classList.add('is-dragging');
      });

      overlay.addEventListener('pointerup', (event) => {
        overlay.classList.remove('is-dragging');
        if (!down) return;
        const dx = Math.abs(event.clientX - down.x);
        const dy = Math.abs(event.clientY - down.y);
        down = null;
        if (dx >= 6 || dy >= 6) return;

        const prev = overlay.style.pointerEvents;
        overlay.style.pointerEvents = 'none';
        const target = document.elementFromPoint(event.clientX, event.clientY);
        overlay.style.pointerEvents = prev || '';

        const card = target && target.closest('[data-marquee-index]');
        if (!card) return;
        openMarqueeLightbox(viewport, slides, card);
      });

      overlay.addEventListener('pointercancel', () => {
        down = null;
        overlay.classList.remove('is-dragging');
      });
    }

    track.querySelectorAll('[data-marquee-index]').forEach((card) => {
      let down = null;

      card.addEventListener('pointerdown', (event) => {
        down = { x: event.clientX, y: event.clientY };
      });

      card.addEventListener('pointerup', (event) => {
        if (!down) return;
        const dx = Math.abs(event.clientX - down.x);
        const dy = Math.abs(event.clientY - down.y);
        down = null;
        if (dx >= 6 || dy >= 6) return;
        openMarqueeLightbox(viewport, slides, card);
      });

      card.addEventListener('pointercancel', () => {
        down = null;
      });
    });

    return embla;
  }

  function initLightbox(root) {
    const lightbox = root.querySelector('.mindpatterns-marquee-lightbox');
    if (!lightbox) return;

    const closeButton = lightbox.querySelector('.mindpatterns-marquee-lightbox__close');
    const backdrop = lightbox.querySelector('.mindpatterns-marquee-lightbox__backdrop');
    const viewport = lightbox.querySelector('.mindpatterns-marquee-lightbox__viewport');
    const track = lightbox.querySelector('.mindpatterns-marquee-lightbox__track');
    let embla = null;
    let touchStart = null;

    function closeLightbox() {
      lightbox.hidden = true;
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      if (embla) embla.destroy();
      embla = null;
      track.innerHTML = '';
    }

    function openLightbox(slides, startIndex) {
      track.innerHTML = slides
        .map(
          (slide) => `
            <div class="mindpatterns-marquee-lightbox__slide">
              <div class="mindpatterns-marquee-lightbox__frame">
                <div class="mindpatterns-marquee-lightbox__image-wrap" data-lightbox-nav>
                  <img src="${slide.fullSrc}" alt="" draggable="false" loading="eager">
                </div>
              </div>
            </div>`,
        )
        .join('');

      lightbox.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';

      embla = EmblaCarousel(viewport, { loop: true, align: 'center' });
      embla.scrollTo(startIndex, true);

      track.querySelectorAll('[data-lightbox-nav]').forEach((frame) => {
        frame.addEventListener('click', (event) => {
          event.stopPropagation();
          const rect = frame.getBoundingClientRect();
          const x = event.clientX - rect.left;
          if (x < rect.width * 0.5) embla.scrollPrev(true);
          else embla.scrollNext(true);
        });
      });
    }

    function handleLightboxSurfaceClick(event) {
      if (lightbox.hidden) return;
      if (event.target.closest('[data-lightbox-nav]')) return;
      if (event.target.closest('.mindpatterns-marquee-lightbox__close')) return;
      closeLightbox();
    }

    root.addEventListener('marquee:open', (event) => {
      openLightbox(event.detail.slides, event.detail.index);
    });

    closeButton.addEventListener('click', closeLightbox);
    backdrop.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', handleLightboxSurfaceClick);

    window.addEventListener('keydown', (event) => {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') embla && embla.scrollPrev();
      if (event.key === 'ArrowRight') embla && embla.scrollNext();
    });

    lightbox.addEventListener('touchstart', (event) => {
      const touch = event.touches[0];
      touchStart = { x: touch.clientX, y: touch.clientY, moved: false };
    }, { passive: true });

    lightbox.addEventListener('touchmove', (event) => {
      if (!touchStart) return;
      const touch = event.touches[0];
      const dx = touch.clientX - touchStart.x;
      const dy = touch.clientY - touchStart.y;
      if (Math.abs(dx) > 6 || Math.abs(dy) > 6) touchStart.moved = true;
      if (Math.abs(dy) > 40 && Math.abs(dy) > Math.abs(dx) * 1.2) {
        touchStart = null;
        closeLightbox();
      }
    }, { passive: true });

    lightbox.addEventListener('touchend', () => {
      touchStart = null;
    });
  }

  function collectSlides(root, row) {
    const viewport = root.querySelector(`[data-marquee-row="${row}"]`);
    if (!viewport) return [];

    const slides = [];
    const seen = new Set();

    viewport.querySelectorAll('.mindpatterns-marquee__card').forEach((card) => {
      const index = Number(card.dataset.marqueeIndex);
      if (!Number.isFinite(index) || seen.has(index)) return;
      seen.add(index);

      const img = card.querySelector('img');
      if (!img) return;

      slides[index] = {
        cardSrc: img.currentSrc || img.src,
        fullSrc: card.dataset.fullSrc || img.src,
      };
    });

    return slides.filter(Boolean);
  }

  function initSection(section) {
    if (!section || section.dataset.marqueeReady === 'true') return;
    section.dataset.marqueeReady = 'true';

    const topSlides = collectSlides(section, 'top');
    const bottomSlides = collectSlides(section, 'bottom');
    if (!topSlides.length && !bottomSlides.length) return;

    const topViewport = section.querySelector('[data-marquee-row="top"]');
    const bottomViewport = section.querySelector('[data-marquee-row="bottom"]');

    initRow(topViewport, topSlides, 'forward');
    initRow(bottomViewport, bottomSlides, 'backward');
    initLightbox(section);
  }

  function initAll() {
    document.querySelectorAll('.mindpatterns-marquee').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.mindpatterns-marquee') || event.target.closest('.mindpatterns-marquee');
    if (section) {
      section.dataset.marqueeReady = 'false';
      initSection(section);
    }
  });
})();
